module.exports = __webpack_public_path__ + "./docs/img/vox-engine.cf329997ebbf03bae3728ebbde4692b4.svg";